import type { PropsWithChildren } from "react";
import { AddRiskModalWithPolicy } from "./add-risk-bulk-modal-with-policy";

interface AddRiskVideoModalProps extends PropsWithChildren {
  videoId: string;
  existingRiskIds: string[];
  onSuccess: () => void;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export const AddRiskVideoModal = ({ videoId, existingRiskIds, ...props }: AddRiskVideoModalProps) => (
  <AddRiskModalWithPolicy variant="single" selectedVideos={[videoId]} disabledRiskIds={existingRiskIds} {...props} />
);
